import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';
import { mergeLogOptions } from './LoggableError';

export interface FetchErrorConstructorProps {
    status: number;
    statusText: string;
    fetchRetryN: number;
    error?: string;
    requestUrl: string;
    loggerFields: SafeLogErrorOptions;
}

export class FetchError extends BaseError {
    public status: number;
    public error: Maybe<string>;

    public static isClientError(error: unknown): error is FetchError {
        return FetchError.is(error) && error.isClientError();
    }

    constructor({ status, statusText, error, requestUrl, fetchRetryN, loggerFields }: FetchErrorConstructorProps) {
        super(
            error || statusText,
            mergeLogOptions(loggerFields, {
                additional: {
                    requestUrl,
                    status,
                    statusText,
                    error,
                    fetchRetryN,
                },
                level: 'error',
            }) as SafeLogErrorOptions
        );

        this.status = status;
        this.error = error;

        Object.setPrototypeOf(this, FetchError.prototype);
    }

    public isClientError() {
        return this.status >= 400 && this.status < 500;
    }
}
